module.exports = __webpack_public_path__ + "static/media/iphone_ios_dark.3bd43f00.svg";